import React, { useEffect, useState } from 'react'
import "moment/locale/ja";
import ajax from '../../common/components/ajax.jsx'
import Constants from '../../common/components/constants.jsx'
import { CircularProgress } from '@mui/material';
import { Box } from '@mui/material';
import { Button } from '@mui/material';
import { TextField } from '@mui/material';
import { Select } from '@mui/material';
import { MenuItem } from '@mui/material';
import { Modal } from '@mui/material';
import { Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import ContentHeader from './content-header.jsx';
import { FormControl } from '@mui/material'
import { InputLabel } from '@mui/material'
import { RadioGroup } from '@mui/material'
import { FormControlLabel } from '@mui/material'
import { Radio } from '@mui/material'
import FormHelperText from '@mui/material/FormHelperText';
import Slider from '@mui/material/Slider';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import DoneIcon from '@mui/icons-material/Done';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

function valueLabelFormatPixel(value) {
    return `${value}%`;
}

function valueLabelFormatSeconds(value) {
    return `${value}秒`;
}

function Settings(props) {
    const [isLoading,setIsLoading] = useState(true)

    const editAuthorized = (props.auth.hasOwnProperty('role') &&
                            props.auth.role.hasOwnProperty('EDIT_SETTING') &&
                            props.auth.role.EDIT_SETTING)

    const [scrollStartTime,setScrollStartTime] = useState(props.SCROLL_START_TIME)
    const [scrollSpeed,setScrollSpeed] = useState(props.SCROLL_SPEED)
    const [scrollEndTime,setScrollEndTime] = useState(props.SCROLL_END_TIME)
    const [noScrollEndTime,setNoScrollEndTime] = useState(props.NO_SCROLL_END_TIME)
    const [noTopicEndTime,setNoTopicEndTime] = useState(props.NO_TOPIC_END_TIME)

    const [userContributedTopicsPatrolledStatusDefaultValue,setUserContributedTopicsPatrolledStatusDefaultValue] = useState("")

    const [snsTopicLifetimeDays,setSnsTopicLifetimeDays] = useState("")

    const [alertTitle,setAlertTitle] = useState("")
    const [alertBody,setAlertBody] = useState("")

    const [alertModalIsOpen,setAlertModalIsOpen] = useState(false)
    const [loadModalIsOpen,setLoadModalIsOpen] = useState(false)
    const [resetModalIsOpen,setResetModalIsOpen] = useState(false)

    // ShareTilesの設定値
    const [city, setCity] = useState("Tokyo")

    const [modalIsGallery, setModalIsGallery] = useState(true)
    const [modalContentLifeTime, setModalContentLifeTime]  = useState(30)

    const [topicTransitionMethod, setTopicTransitionMethod] = useState("snap")
    const [shareTilesScrollSpeed, setShareTilesScrollSpeed] = useState(50)
    const [snapLifeTime, setSnapLifeTime] = useState(8)

    const [particleLifeDelay, setParticleLifeDelay] = useState(6)
    const [particleQuantityRatio, setParticleQuantityRatio] = useState(50)

    useEffect(()=>{
        getSettings()
    },[])

    /**
     * 通信してTopicsの一覧を取得し、
     * stateのitemsに全ての情報を格納します
     */
    const getSettings = () => {
        console.log(process.env.REACT_APP_API_DOMAIN)
        ajax.post(
            Constants.URLs.GET_KS_SETTINGS,
            {user_id: props.auth.userId},
            (successJson) => {
                if(!successJson.hasOwnProperty('data')){
                    setIsLoading(false);
                    return;
                }

                successJson.data.forEach(function(val){
                    switch(val.KEY_NAME){
                        case 'scroll_start_time':
                            setScrollStartTime(val.VALUE)
                            break;
                        case 'scroll_end_time':
                            setScrollEndTime(val.VALUE)
                            break;
                        case 'scroll_speed':
                            setScrollSpeed(val.VALUE)
                            break;
                        case 'no_scroll_end_time':
                            setNoScrollEndTime(val.VALUE)
                            break;
                        case 'no_topic_end_time':
                            setNoTopicEndTime(val.VALUE)
                            break;

                        // ユーザー投稿
                        case 'user_contributed_topics_patrolled_status_default_value':
                            setUserContributedTopicsPatrolledStatusDefaultValue(val.VALUE)
                            break;

                        // wall
                        case 'sns_topic_lifetime_days':
                            setSnsTopicLifetimeDays(val.VALUE)
                            break;

                        // ShareTiles
                        case "city":
                            setCity(val.VALUE)
                            break;
                        case "modal_is_gallery":
                            setModalIsGallery(val.VALUE)
                            break;
                        case "modal_content_life_time":
                            setModalContentLifeTime(val.VALUE)
                            break;
                        case "topic_transition_method":
                            setTopicTransitionMethod(val.VALUE)
                            break;
                        case "share_tiles_scroll_speed":
                            setShareTilesScrollSpeed(val.VALUE)
                            break;
                        case "snap_life_time":
                            setSnapLifeTime(val.VALUE)
                            break;
                        case "particle_life_delay":
                            setParticleLifeDelay(val.VALUE)
                            break;
                        case "particle_quantity_ratio":
                            setParticleQuantityRatio(val.VALUE)
                            break;
                        default:
                    }
                }, this);

                setIsLoading(false)
            },
            (errorJson) => {
                setAlertTitle(errorJson.response)
                setAlertBody(errorJson.message + errorJson.code)
                setAlertModalIsOpen(true)
            }
        );
    }

    const postNewSettings =()=> {
        if(!editAuthorized) return;

        if([
            scrollStartTime,
            scrollEndTime,
            scrollSpeed,
            noScrollEndTime,
            noTopicEndTime,
            userContributedTopicsPatrolledStatusDefaultValue,
            city,
            modalIsGallery,
            modalContentLifeTime,
            topicTransitionMethod,
            shareTilesScrollSpeed,
            snapLifeTime,
            particleLifeDelay,
            particleQuantityRatio
        ].indexOf(null) !== -1) return

        let postData = {
            scroll_start_time:  scrollStartTime,
            scroll_end_time:    scrollEndTime,
            scroll_speed:       scrollSpeed,
            no_scroll_end_time: noScrollEndTime,
            no_topic_end_time:  noTopicEndTime,

            // ユーザー投稿
            user_contributed_topics_patrolled_status_default_value:  userContributedTopicsPatrolledStatusDefaultValue,

            // ShareTiles
            city:                      city,
            modal_is_gallery:          modalIsGallery,
            modal_content_life_time:   modalContentLifeTime,
            topic_transition_method:   topicTransitionMethod,
            share_tiles_scroll_speed: shareTilesScrollSpeed,
            snap_life_time:            snapLifeTime,
            particle_life_delay:       particleLifeDelay,
            particle_quantity_ratio:   particleQuantityRatio
        };

        // wall
        if(snsTopicLifetimeDays !== null){
            postData.sns_topic_lifetime_days = snsTopicLifetimeDays;
        }

        setLoadModalIsOpen(true)
        ajax.post(
            Constants.URLs.EDIT_KS_SETTINGS,
            postData,
            (successJson)=> {
                setLoadModalIsOpen(false)
            },
            (errorJson)=> {
                setAlertTitle(errorJson.response)
                setAlertBody(errorJson.message + errorJson.code)
                setAlertModalIsOpen(true)
                setLoadModalIsOpen(false)
            }
        );
    }

    // 初期化
    const postResetSettings =()=>{
        setResetModalIsOpen(false)
        setLoadModalIsOpen(true)

        const postData = {
            scroll_start_time:  10000,
            scroll_end_time:    10000,
            scroll_speed:       30,
            no_scroll_end_time: 20000,
            no_topic_end_time:  10000,
            // ShareTiles
            modal_is_gallery: true,
            modal_content_life_time: 30,
            topic_transition_method: "snap",
            share_tiles_scroll_speed: 50,
            snap_life_time: 8,
            particle_life_delay: 6,
            particle_quantity_ratio: 50,
            sns_topic_lifetime_days: 7,
            user_contributed_topics_patrolled_status_default_value: "NOTYET"
        };
        setScrollStartTime(postData.scroll_start_time)
        setScrollEndTime(postData.scroll_end_time)
        setScrollSpeed(postData.scroll_speed)
        setNoScrollEndTime(postData.no_scroll_end_time)
        setNoTopicEndTime(postData.no_topic_end_time)

        setModalIsGallery(postData.modal_is_gallery)
        setModalContentLifeTime(postData.modal_content_life_time)
        setTopicTransitionMethod(postData.topic_transition_method)
        setShareTilesScrollSpeed(postData.share_tiles_scroll_speed)
        setSnapLifeTime(postData.snap_life_time)
        setParticleLifeDelay(postData.particle_life_delay)
        setParticleQuantityRatio(postData.particle_quantity_ratio)

        ajax.post(
            Constants.URLs.EDIT_KS_SETTINGS,
            postData,
            (successJson) => {
                setLoadModalIsOpen(false)
            },
            (errorJson) => {
                setAlertTitle(errorJson.response)
                setAlertBody(errorJson.message + errorJson.code)
                setAlertModalIsOpen(true)
                setLoadModalIsOpen(false)
            }
        );
    }

    const onUpdateScrollSpeed =(val)=> {
        if(!editAuthorized) return;
        setScrollSpeed(val)
    }
    const onUpdateNoScrollEndTime=(val)=> {
        if(!editAuthorized) return;
        setNoScrollEndTime(val)
    }

    const onUpdateNoTopicEndTime=(val)=> {
        if(!editAuthorized) return;
        setNoTopicEndTime(val)
    }

    const onUpdateScrollStartTime=(val)=> {
        if(!editAuthorized) return;
        setScrollStartTime(val)
    }

    const onUpdateScrollEndTime=(val)=> {
        if(!editAuthorized) return;
        setScrollEndTime(val)
    }

    const onSelectedPatrolledStatus=(val)=> {
        if(!editAuthorized) return;
        setUserContributedTopicsPatrolledStatusDefaultValue(val)
    }

    const onUpdateSNSTopicLifetimeDays =(val) =>{
        if(!editAuthorized) return;
        setSnsTopicLifetimeDays(val)
    }



    // wallにおける設定値
    // この設定値のすべてが指定済み (nullではない) の場合、wallの設定値も設定画面に表示する
    let wallOptions = [
        snsTopicLifetimeDays
    ];

    return(
        <div id="Category">
            <ContentHeader
             title={"設定"}
             breadCrumbItems={[{title:"設定",icon:"notification",path:""}]}
            />

            { isLoading ?
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            :
                <Paper sx={{ width: '100%', overflow: 'hidden' ,p:"10px 40px 10px 40px"}}>
                    {/* <FormControl
                        fullWidth
                        variant="standard"
                        component="fieldset"
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                            天気を取得する都市名
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊ローマ字で日本の都市を入力してください</FormHelperText>
                        <TextField
                            required
                            variant="standard"
                            disabled={!editAuthorized}
                            placeholder="ex)Tokyo,Osaka"
                            value={city}
                            onChange = {(evt) => setCity(evt.currentTarget.value)}

                        />
                    </FormControl> */}

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                            詳細画面をギャラリーモードにする
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊カードの詳細画面にミニビューが追加され、自動遷移するようになります</FormHelperText>
                        <RadioGroup
                            row
                            value={modalIsGallery}
                            onChange = {(evt) => setModalIsGallery(evt.target.value === "true")}
                        >
                            <FormControlLabel disabled={!editAuthorized} value="true" control={<Radio />} label="する" />
                            <FormControlLabel disabled={!editAuthorized} value="false" control={<Radio />} label="しない" />
                        </RadioGroup>
                    </FormControl>

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        fullWidth
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                            ギャラリーモードで、次のトピックに遷移するまでの待ち時間
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊画面にタッチされると再度カウントが始まります。表示コンテンツが動画の場合は、動画終了後にカウントが始まります</FormHelperText>
                        <div style={{height:"40px"}}/>
                        <Slider
                            size="small"
                            valueLabelFormat={valueLabelFormatSeconds}
                            value={modalContentLifeTime}
                            aria-label="Small"
                            valueLabelDisplay="on"
                            min={10}
                            max={60}
                            marks={[{value:10,label:"10秒"},{value:60,label:"60秒"}]}
                            onChange = {(evt) => setModalContentLifeTime(evt.target.value)}
                            disabled = {!modalIsGallery || !editAuthorized}
                        />
                    </FormControl>

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                            トピックの遷移の仕方
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊優先配信以外のトピックが遷移されます</FormHelperText>
                        <RadioGroup
                            row
                            value={topicTransitionMethod}
                            onChange = {(evt) => setTopicTransitionMethod(evt.target.value)}
                        >
                            <FormControlLabel disabled={!editAuthorized} value="snap" control={<Radio />} label="スナップ" />
                            <FormControlLabel disabled={!editAuthorized} value="scroll" control={<Radio />} label="スクロール" />
                        </RadioGroup>
                    </FormControl>

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        fullWidth
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                            次のトピックに遷移するまでの待ち時間
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊システム立ち上げ時と、画面にタッチされた時に一時停止します</FormHelperText>
                        <div style={{height:"40px"}}/>
                        <Slider
                            size="small"
                            valueLabelFormat={valueLabelFormatSeconds}
                            value={snapLifeTime}
                            aria-label="Small"
                            valueLabelDisplay="on"
                            min={6}
                            max={12}
                            step={0.5}
                            marks={[{value:6,label:"6秒"},{value:12,label:"12秒"}]}
                            onChange = {(evt) => setSnapLifeTime(evt.target.value)}
                            disabled = {topicTransitionMethod === "scroll" || !editAuthorized}
                        />
                    </FormControl>

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        fullWidth
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                            スクロール速度
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊システム立ち上げ時と、画面にタッチされた時に一時停止します</FormHelperText>
                        <div style={{height:"40px"}}/>
                        <Slider
                            size="small"
                            valueLabelFormat={valueLabelFormatPixel}
                            value={shareTilesScrollSpeed}
                            aria-label="Small"
                            valueLabelDisplay="on"
                            min={1}
                            max={100}
                            marks={[{value:1,label:"遅い"},{value:100,label:"早い"}]}
                            onChange = {(evt) => setShareTilesScrollSpeed(evt.target.value)}
                            disabled = {topicTransitionMethod === "snap" || !editAuthorized}
                        />
                    </FormControl>

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        fullWidth
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                            トピックのエフェクトが発生するまでの待ち時間
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊いいねボタンからハートが発生する頻度を調整できます</FormHelperText>
                        <div style={{height:"40px"}}/>
                        <Slider
                            size="small"
                            valueLabelFormat={valueLabelFormatSeconds}
                            value={particleLifeDelay}
                            aria-label="Small"
                            valueLabelDisplay="on"
                            min={0}
                            max={12}
                            marks={[{value:0,label:"0秒"},{value:12,label:"12秒"}]}
                            onChange = {(evt) => setParticleLifeDelay(evt.target.value)}
                            disabled = {!editAuthorized}
                        />
                    </FormControl>

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        fullWidth
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                            トピックのエフェクトの量
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊一度にハートが発生する量を調整できます</FormHelperText>
                        <div style={{height:"40px"}}/>
                        <Slider
                            size="small"
                            valueLabelFormat={valueLabelFormatPixel}
                            value={particleQuantityRatio}
                            aria-label="Small"
                            valueLabelDisplay="on"
                            min={0}
                            max={100}
                            marks={[{value:0,label:"無し"},{value:100,label:"多い"}]}
                            onChange = {(evt) => setParticleQuantityRatio(evt.target.value)}
                            disabled = {!editAuthorized}
                        />
                    </FormControl>
                    {/* shareTilesの設定画面 */}
                    <Divider />
                    {/* shareWallの設定画面 */}

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        fullWidth
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                            スクロール速度
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊</FormHelperText>
                        <div style={{height:"40px"}}/>
                        <Slider
                            size="small"
                            valueLabelFormat={valueLabelFormatPixel}
                            value={scrollSpeed}
                            aria-label="Small"
                            valueLabelDisplay="on"
                            min={1}
                            max={100}
                            marks={[{value:1,label:"遅い"},{value:100,label:"早い"}]}
                            onChange = {(evt) => onUpdateScrollSpeed(evt.target.value)}
                            disabled = {!editAuthorized}
                        />
                    </FormControl>

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        fullWidth
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                        スクロールが発生しないコンテンツの遷移までの待ち時間
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊</FormHelperText>
                        <div style={{height:"40px"}}/>
                        <Slider
                            size="small"
                            valueLabelFormat={valueLabelFormatSeconds}
                            value={noScrollEndTime / 1000}
                            aria-label="Small"
                            valueLabelDisplay="on"
                            min={1}
                            max={60}
                            marks={[{value:1,label:"1秒"},{value:60,label:"60秒"}]}
                            onChange = {(evt) => onUpdateNoScrollEndTime(evt.target.value * 1000)}
                            disabled = {!editAuthorized}
                        />
                    </FormControl>

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        fullWidth
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                        トピックのないカテゴリが次のカテゴリに遷移するまでの待ち時間
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊</FormHelperText>
                        <div style={{height:"40px"}}/>
                        <Slider
                            size="small"
                            valueLabelFormat={valueLabelFormatSeconds}
                            value={noTopicEndTime/ 1000}
                            aria-label="Small"
                            valueLabelDisplay="on"
                            min={1}
                            max={60}
                            marks={[{value:1,label:"1秒"},{value:60,label:"60秒"}]}
                            onChange = {(evt) => onUpdateNoTopicEndTime(evt.target.value * 1000)}
                            disabled = {!editAuthorized}
                        />
                    </FormControl>

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        fullWidth
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                        トピックが表示されてスクロールが開始されるまでの待ち時間
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊</FormHelperText>
                        <div style={{height:"40px"}}/>
                        <Slider
                            size="small"
                            valueLabelFormat={valueLabelFormatSeconds}
                            value={scrollStartTime/ 1000}
                            aria-label="Small"
                            valueLabelDisplay="on"
                            min={1}
                            max={60}
                            marks={[{value:1,label:"1秒"},{value:60,label:"60秒"}]}
                            onChange = {(evt) => onUpdateScrollStartTime(evt.target.value * 1000)}
                            disabled = {!editAuthorized}
                        />
                    </FormControl>

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        fullWidth
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                        トピックのスクロールが終了してから、次のトピックに遷移するまでの待ち時間
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊</FormHelperText>
                        <div style={{height:"40px"}}/>
                        <Slider
                            size="small"
                            valueLabelFormat={valueLabelFormatSeconds}
                            value={scrollEndTime/ 1000}
                            aria-label="Small"
                            valueLabelDisplay="on"
                            min={1}
                            max={60}
                            marks={[{value:1,label:"1秒"},{value:60,label:"60秒"}]}
                            onChange = {(evt) => onUpdateScrollEndTime(evt.target.value * 1000)}
                            disabled = {!editAuthorized}
                        />
                    </FormControl>
                    {/* shareWallの設定画面 */}
                    <Divider/>
                    {/* 管理画面の設定画面 */}

                    <FormControl
                        variant="standard"
                        component="fieldset"
                        fullWidth
                        sx = {{mb:"20px"}}
                    >
                        <InputLabel size="small" shrink={false} >
                        ユーザー投稿の承認状態
                        </InputLabel>
                        <div style={{height:"40px"}}/>
                        <FormHelperText>＊トピックがユーザーによって投稿されたとき、承認状態をデフォルトで次の値にします</FormHelperText>
                        <Select
                            disabled={!editAuthorized}
                            variant="standard"
                            value={userContributedTopicsPatrolledStatusDefaultValue}
                            onChange={(event) => { onSelectedPatrolledStatus(event.target.value); }}
                        >
                            <MenuItem value="NOTYET">未確認</MenuItem>
                            <MenuItem value="AUTO_ACCEPTED">自動承認</MenuItem>
                            <MenuItem value="REJECTED">却下</MenuItem>
                        </Select>
                    </FormControl>

                    {wallOptions.indexOf(null) === -1 &&
                            <FormControl
                            fullWidth
                            variant="standard"
                            component="fieldset"
                            sx = {{mb:"20px"}}
                            >
                                {/* shareTilesの設定画面 */}
                                <InputLabel size="small" shrink={false} >
                                    SNSから収集したトピックのデフォルトの掲載日数
                                </InputLabel>
                                <div style={{height:"40px"}}/>
                                <FormHelperText>＊半角数字で入力してください</FormHelperText>
                                <TextField
                                    required
                                    variant="standard"
                                    disabled={!editAuthorized}
                                    placeholder="ex)365"
                                    InputProps={{
                                    endAdornment: <InputAdornment position="end">日</InputAdornment>,
                                    }}
                                    value={snsTopicLifetimeDays}
                                    onChange = {(evt) => onUpdateSNSTopicLifetimeDays(evt.currentTarget.value)}
                                />
                            </FormControl>
                    }

                    <div style={{textAlign:"right"}} >
                        <Button
                        disabled={!editAuthorized}
                        sx={{marginRight:"10px"}}
                        color={"secondary"}
                        variant={"outlined"}
                        size={"large"}
                        onClick={() => { setResetModalIsOpen(true) }}
                        >初期化</Button>

                        <Button
                        disabled={!editAuthorized}
                        color={"primary"}
                        variant={"contained"}
                        size={"large"}
                        startIcon={<DoneIcon/>}
                        onClick={() => { postNewSettings(); }}
                        >保存する</Button>
                    </div>
                </Paper>
            }

            <Dialog
                open={resetModalIsOpen}
                onClose={() => setResetModalIsOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>待機時間設定の初期化</DialogTitle>
                <DialogContent>
                    <div>
                    全ての設定の初期化を行います。よろしいですか？
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button style={{ width: '150px' }} onClick={()=>{postResetSettings()}} color="primary">
                    初期化
                    </Button>
                    <Button style={{ width: '150px' }} onClick={() => setResetModalIsOpen(false)} color="primary">
                    キャンセル
                    </Button>
                </DialogActions>
            </Dialog>

            <Modal
             open={loadModalIsOpen}
             onClose={() => setLoadModalIsOpen(false)}
             aria-labelledby="load-modal-title"
             aria-describedby="load-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 200,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography id="load-modal-title" variant="h6" component="div" sx={{ textAlign: 'center' }}>
                        Loading...
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        <CircularProgress />
                    </Box>
                </Box>
            </Modal>

            <Dialog
             open={alertModalIsOpen}
             onClose={() => setAlertModalIsOpen(false)}
             aria-labelledby="alert-modal-title"
             maxWidth={"sm"}
             fullWidth={true}
            >
                <DialogTitle id="alert-modal-title">{alertTitle}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {alertBody}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setAlertModalIsOpen(false)}>
                        閉じる
                    </Button>
                </DialogActions>
            </Dialog>
    </div>
    )
}

export default Settings

Settings.defaultProps = {
    role: {},

    SCROLL_START_TIME:  10000,
    SCROLL_END_TIME:    10000,
    SCROLL_SPEED:       30,
    NO_SCROLL_END_TIME: 20000,
    NO_TOPIC_END_TIME:  10000,

    // ユーザー投稿
    user_contributed_topics_patrolled_status_default_value: 'NOTYET',

    // wall
    sns_topic_lifetime_days: 7,

    // ShareTiles
    city: "tokyo",
    modal_is_gallery: true,
    modal_content_life_time: 30,
    topic_transition_method: "snap",
    share_tiles_scroll_speed: 50,
    snap_life_time: 8,
    particle_life_delay: 6,
    particle_quantity_ratio: 50

};